import React from 'react'
// import { ListSubheader } from '@material-ui/core'
// import { getLang } from '../../app/selectors/lang'
// import SedaKeyMetricListHeader from './SedaKeyMetricListHeader'
// import SedaKeyMetricListItem from './SedaKeyMetricListItem'
// import {
//   getMetricIdFromVarName,
//   getVarNameWithUnit
// } from '../../app/selectors'
// import { useMetric, useUnit } from '../../app/hooks'

import SedaMetricSelect from '../../controls/SedaMetricSelect'

const SedaLocationKeyMetrics = ({ location }) => {

  return (
    <SedaMetricSelect
      location={location}
    />
  )
}

SedaLocationKeyMetrics.propTypes = {

}

export default SedaLocationKeyMetrics
